import { motion, useReducedMotion } from 'framer-motion';
import { CatalogItem } from '../../api/CataloguesAPI';
import PublicCatalogLookCard from './PublicCatalogLookCard';

type PublicCatalogLookGridProps = {
  items: CatalogItem[];
  isSaved: (itemUuid?: string) => boolean;
  onOpen: (item: CatalogItem) => void;
  onToggleSave: (itemUuid?: string) => void;
};

const PublicCatalogLookGrid = ({ items, isSaved, onOpen, onToggleSave }: PublicCatalogLookGridProps) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6 lg:grid-cols-4"
      initial={prefersReducedMotion ? false : 'hidden'}
      animate="show"
      variants={{
        hidden: {},
        show: {
          transition: { staggerChildren: prefersReducedMotion ? 0 : 0.06 },
        },
      }}
    >
      {items.map((item) => (
        <motion.div
          key={item.uuid || item.name}
          variants={{
            hidden: { opacity: 0, y: prefersReducedMotion ? 0 : 18 },
            show: { opacity: 1, y: 0, transition: { duration: 0.45 } },
          }}
        >
          <PublicCatalogLookCard
            item={item}
            saved={isSaved(item.uuid)}
            onOpen={() => onOpen(item)}
            onToggleSave={() => onToggleSave(item.uuid)}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default PublicCatalogLookGrid;
